import React from 'react';
import { Box, Button, Popover } from '@landr/maestro';
import { Trans } from '@lingui/macro';
import { searchV3FilterType } from 'components/Filters/Filters';
import useSearchTools from '../hooks/useSearchTools';

const SearchToolsPopoverTrigger = ({
    onToggle,
    ref,
    isSearchBarDisabled,
    toolsType,
}: {
    toolsType: searchV3FilterType;
    onToggle: () => void;
    ref: React.RefObject<HTMLButtonElement>;
    isSearchBarDisabled: boolean;
}) => {
    const {
        isBpmActive,
        isKeyActive,
        isTypeActive,
        ActiveTypeLabel,
        isTypeFilter,
        isBpmFilter,
        isKeyFilter,
    } = useSearchTools({ toolsType });

    let isActiveFilter = false;

    if (isTypeFilter && isTypeActive) {
        isActiveFilter = true;
    }
    if (isBpmFilter && isBpmActive) {
        isActiveFilter = true;
    }
    if (isKeyFilter && isKeyActive) {
        isActiveFilter = true;
    }

    return (
        <Popover.Trigger>
            <Button
                onClick={onToggle}
                ref={ref}
                isDropdown
                isRounded
                variant="ghost"
                backgroundColor={
                    isActiveFilter ? 'surface.neutral.medium.hover' : undefined
                }
                isDisabled={isSearchBarDisabled}
                textAlign="left"
            >
                <Box minWidth={isTypeFilter ? '135px' : undefined}>
                    {isTypeFilter && ActiveTypeLabel}
                    {isBpmFilter && <Trans>BPM</Trans>}
                    {isKeyFilter && <Trans>Key</Trans>}
                </Box>
            </Button>
        </Popover.Trigger>
    );
};

export default SearchToolsPopoverTrigger;
